import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

// Own constants/actions/components
import invoice from 'assets/invoice.svg';

const ResumenSucces = (props) => {
  const { resumen } = props;

  function add(accumulator, a) {
    return accumulator + a;
  }

  const sumTotalPoints = () => {
    const arrayPoints = [];
    resumen.map((item) => {
      return arrayPoints.push(Number(item.cost));
    });
    const sum = arrayPoints.reduce(add, 0);
    return sum.toLocaleString('es-MX');
  };

  return (
    <div className="bg-color-westar p-15 mt-30 mt-lg-60">
      <img src={invoice} alt="shopping-cart-icon" className="py-15" />
      <h3>Resumen de tu pedido</h3>
      <h3 className="pt-30 pb-15">Experiencias</h3>
      {
        resumen.map((ticket, index) => {
          return (
            /* eslint-disable */
            <Row className="gift-label my-15" key={index}>
              <Col xs={8} lg={8}>
                <p className="ft-12 text-tangaroa">
                  {ticket.isGift === true ? (
                    <i className="fas fa-gift mr-2" />
                  ) : '' }
                  {ticket.title}
                </p>
              </Col>
              <Col xs={4} lg={4} className="text-right">
                <b className="text-tangaroa">
                  {(Number(ticket.cost)).toLocaleString('es-MX')}
                </b>
              </Col>

              {
                  ticket.experienceType === 'FACE_TO_FACE' || ticket.experienceType === 'MASTERCLASS' ||
                  ticket.experienceType === 'TRAVEL' || ticket.experienceType === 'TRAVEL_INTERNATIONAL' ? (
                    ticket.memberList.map((member, idx) => (
                      <div key={idx} className="px-3">
                        <h3 className="text-tangaroa mt-20">
                          <i className="fas fa-user mr-2" />
                          {idx === 0 ? 'Titular de reservación' : `Acompañante ${idx}`}
                        </h3>
                        <p className="pl-25 mb-1">{member.name}</p>
                        <p className="pl-25 mb-1">{member.birthDate}</p>
                        <p className="pl-25 mb-1">{member.email}</p>
                        <p className="pl-25 mb-1">{member.phoneNumber}</p>
                      </div>
                    ))
                  ) : ''
                }
            </Row>
          );
        })
      }
      <Row className="pt-30">
        <Col xs={8} lg={8}>
          <h5 className="ft-14 text-tangaroa">
            <b>Total de Puntos Aeroméxico Rewards</b>
          </h5>
        </Col>
        <Col xs={4} lg={4} className="ft-14 text-right text-dark-blue">
          <b>
            { sumTotalPoints() }
          </b>
        </Col>
      </Row>
    </div>
  );
};

ResumenSucces.propTypes = {
  resumen: PropTypes.array.isRequired,
};

export default ResumenSucces;
